import { render, staticRenderFns } from "./ProfileReadOnlyPage.vue?vue&type=template&id=36713195"
import script from "./ProfileReadOnlyPage.vue?vue&type=script&lang=js"
export * from "./ProfileReadOnlyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports